var csrf_token,
  ContactForm = {},
  mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  formElem = document.querySelector("#inbound-meetups-form");

ContactForm.formObj = document.querySelector("#inbound-meetups-form");
ContactForm.nameField = document.querySelector("#form-name");
ContactForm.emailField = document.querySelector("#form-email");
ContactForm.organizationField = document.querySelector("#form-organization");
ContactForm.meetupField = document.querySelector("#form-meetup");
ContactForm.querySelect = document.querySelector("#support-query-type");
ContactForm.attendeesField = document.querySelector("#form-attendees");
ContactForm.eventField = document.querySelector("#form-event");
ContactForm.sponsorship = document.querySelector(".checkbox-field input");
ContactForm.requestType = document.querySelector("#request_type");
ContactForm.utf8 = document.querySelector("#utf_no");
ContactForm.authenticity = document.querySelector("#authenticity_token");
ContactForm.triggerEmail = document.querySelector("#trigger_email");

/**
 * Recaptcha File load
 */
window.addEventListener("load", function() {
  // load recaptcha JS after page load
  document.addEventListener("click", function () {
    if (typeof grecaptcha === "undefined") {
      var scriptElm = document.createElement("script");
      scriptElm.setAttribute("id", "recaptcha-js");
      scriptElm.setAttribute("type", "text/javascript");
      scriptElm.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?ver=1.0"
      );
      scriptElm.setAttribute("defer", "defer");
      document.body.appendChild(scriptElm);
    }
  });
});

//supportQueryType
new ChosenCustom({
  selector: ContactForm.querySelect,
  ID: "supportQueryType",
  placeholder: "Select Country"
});

// XHR request for user token
bsLib.ajax(
  "GET",
  bsLib.railsHost() + "/user/token.json",
  {},
  false,
  {},
  // Success message for user token.
  function(data) {
    var dataRequest = bsLib.JSONParse(data.response),
      authenticityToken = document.querySelectorAll(
        'input[name="authenticity_token"]'
      );

    for (var i = 0; i < authenticityToken.length; i++) {
      authenticityToken[i].value = dataRequest.csrf_token;
    }

    csrf_token = dataRequest.csrf_token;
  },
  // Custom Error message for user token.
  function() {
    return "user token not working";
  }
);

// email blur validation
if (ContactForm.emailField) {
  ContactForm.emailField.addEventListener("blur", function(event) {
    var validEmail = true,
      that = this,
      submitBtn = document.getElementById("inbound-submit-btn"),
      emailError = document.getElementById("email-error");

    //false valid dataset
    that.dataset.notvalid = "0";

    //remove existing error
    if (emailError) {
      emailError.remove();
    }

    if (that.value.length == 0 || !bsLib.validEmail(that.value)) {
      validEmail = false;
      
      that.classList.add("error-border");
      that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + (that.value.length == 0 ? Messages.salesAndSupportPage.noemail : Messages.salesAndSupportPage.invalidEmail) + '</span>');
    } else {
      that.classList.remove("error-border");
    }

    if (validEmail) {
      //Disable submit button
      if (submitBtn) {
        submitBtn.setAttribute("disabled", "disabled");
        submitBtn.dataset.valueText = submitBtn.value;
        submitBtn.value = Messages.salesAndSupportPage.validateText;
      }

      bsLib.ajax(
        "GET",
        bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value),
        {},
        true,
        {
          "X-CSRF-Token": csrf_token,
          "content-type": "application/x-www-form-urlencoded; charset=utf-8" // Setting content type.
        },
        function(data) {
          var dataRequest = bsLib.JSONParse(data.response);

          //remove disable
          if (submitBtn) {
            submitBtn.removeAttribute("disabled");
            submitBtn.value = submitBtn.dataset.valueText;
          }

          if (dataRequest.valid === false) {
            that.dataset.notvalid = "1";

            that.classList.add("error-border");
            if (that.parentNode.getElementsByClassName("error-message").length === 0) {
              that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + Messages.salesAndSupportPage.invalidEmail + '</span>');
            }
          }
        },
        function() {}
      );
    }
  });
}

var PartnersContact = (function(csrf_token, ContactForm) {
  return {
    init: init,
    resetForm: resetForm,
    validateFields: _validateFields
  };

  function init() {
    var sponsorshipValues = [],
    grecaptchaResponse = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse() : '';

    //With the call() method, you can write a method that can be used on different objects.
    Array.prototype.forEach.call(
      document.querySelectorAll('input[name="sponsorship"]:checked'),
      function(el) {
        sponsorshipValues.push(el.value);
      }
    );

    if (grecaptchaResponse.length === 0) {
      new bsAlert({
        alertType: "error",
        timeout: 5000,
        text: Messages.salesAndSupportPage.noRecaptcha
      });

      return false;
    }

    var properties_data = {
      Organization: ContactForm.organizationField.value,
      City_meetup: ContactForm.meetupField.value,
      Country: ContactForm.querySelect.value,
      Attendees_number: ContactForm.attendeesField.value,
      Event_theme: ContactForm.eventField.value,
      Sponsorship: sponsorshipValues
    };

    // xhr request for sending form data
    bsLib.ajax(
      "POST",
      bsLib.railsHost() + "/capture-lead",
      //form data
      {
        name: ContactForm.nameField.value,
        email: ContactForm.emailField.value,
        properties: JSON.stringify(properties_data),
        authenticity_token: ContactForm.authenticity.value,
        utf8: ContactForm.utf8.value,
        form_name: ContactForm.requestType.value,
        trigger_email: ContactForm.triggerEmail.value,
        "g-recaptcha-response": grecaptchaResponse,
        ga_cid: bsLib.GAClientID()
      },
      false,
      //form header
      {
        "X-CSRF-Token": csrf_token,
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8" // Setting content type.
      },
      //form success
      function(data) {
        var dataRequest = bsLib.JSONParse(data.response);
        if (dataRequest.success === true) {
          var modalContainer = document.querySelector(".thank-you-modal");
          var custModalVideo = new tingle.modal({
            cssClass: ["small-modal-box"],
            onClose: function() {
              custModalVideo.destroy();
            }
          });
          custModalVideo.setContent(modalContainer.innerHTML);
          custModalVideo.open();

          _logFormSubmit("FormSubmitSuccess");
          _afterSubmitSuccess();
        } else {
          console.error("form success failed");
        }
      },
      //form error
      function() {
        _logFormSubmit("FormSubmitError");
      }
    );
  }

  function _validateFields() {
    var formValid = true,
      namerError = document.getElementById("name-error"),
      emailError = document.getElementById("email-error"),
      orgError = document.getElementById("org-error"),
      meetupError = document.getElementById("meetup-error"),
      querySelectError = document.getElementById("querySelect-error"),
      attendeesError = document.getElementById("attendees-error"),
      sponsorshipError = document.getElementById("sponsorship-error");

    //Remove all errors
    removeAllError();

    //name field
    if (ContactForm.nameField.value.length === 0) {
      formValid = _showError(
        ContactForm.nameField,
        namerError,
        "name-error",
        Messages.salesAndSupportPage.invalidName
      );
    }

    //Email validation
    if (ContactForm.emailField.value == "") {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        "email-error",
        Messages.salesAndSupportPage.noemail
      );
    } else if (!ContactForm.emailField.value.match(mailformat)) {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        "email-error",
        Messages.salesAndSupportPage.invalidEmail
      );
    } else if (ContactForm.emailField.dataset.notvalid === "1") {
      formValid = _showError(
        ContactForm.emailField,
        emailError,
        'email-error',
        Messages.salesAndSupportPage.invalidEmail
      );
    }

    //organization Field
    if (ContactForm.organizationField.value.length === 0) {
      formValid = _showError(
        ContactForm.organizationField,
        orgError,
        "org-error",
        Messages.salesAndSupportPage.invalidOrganization
      );
    }

    //meetup Field
    if (ContactForm.meetupField.value.length === 0) {
      formValid = _showError(
        ContactForm.meetupField,
        meetupError,
        "meetup-error",
        Messages.salesAndSupportPage.invalidMeetup
      );
    }

    //country querySelect
    if (ContactForm.querySelect.value.length === 0) {
      formValid = _showError(
        ContactForm.querySelect.parentElement.querySelector(
          ".select-dropdown__button"
        ),
        querySelectError,
        "querySelect-error",
        Messages.salesAndSupportPage.invalidCountry
      );
    }

    //attendees Field
    if (ContactForm.attendeesField.value.length === 0) {
      formValid = _showError(
        ContactForm.attendeesField,
        attendeesError,
        "attendees-error",
        Messages.salesAndSupportPage.invalidSponsorship
      );
    }

    //sponsorship field
    sponsorshipValues = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('input[name="sponsorship"]:checked'),
      function(el) {
        sponsorshipValues.push(el.value);
      }
    );

    if (sponsorshipValues.length === 0) {
      formValid = _showError(
        document.querySelector("#sponsorship_4"),
        sponsorshipError,
        "attendees-error",
        Messages.salesAndSupportPage.invalidSponsorship
      );
    }

    return formValid;
  }

  function removeAllError() {
    //Remove all error element
    var errorMsg = ContactForm.formObj.querySelectorAll(".error-message");
    for (var i = 0; i < errorMsg.length; i++) {
      errorMsg[i].remove();
    }
    //remove error border class
    var errorMsg = ContactForm.formObj.parentElement.querySelectorAll(
      ".error-border"
    );
    for (var i = 0; i < errorMsg.length; i++) {
      errorMsg[i].classList.remove("error-border");
    }
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    inlineError.showError(fieldName, fieldError, errorName, errorMessage);
  }

  function _afterSubmitSuccess() {
    // Hide thank you modal, reset form
    resetFomrTimeout = setTimeout(function() {
      resetForm();
    }, 4000);
  }

  function resetForm() {
    clearTimeout(resetFomrTimeout);
    ContactForm.formObj.reset(); //Reset form

    if (typeof grecaptcha !== "undefined") {
      grecaptcha.reset();
    }
  }

  function _logFormSubmit(status) {
    if (typeof ga !== "undefined") {
      ga("browserstack.send", "event", {
        eventCategory: "Inbound Meetups Forms",
        eventAction: "CtaClick",
        eventLabel: "Submit"
      });
    }
  }
})(csrf_token, ContactForm);

var recaptchaCallback = function() {
  return PartnersContact.init();
};

//Reset captcha if expired
var expiredCaptchaCallback = function() {
  if (typeof grecaptcha !== "undefined") {
    grecaptcha.reset();
  }
};

formElem.addEventListener("submit", function(e) {
  e.preventDefault();
  if (!PartnersContact.validateFields()) {
    return false;
  }

  if (typeof grecaptcha !== "undefined") {
    grecaptcha.execute();
  }
  
  return false;
});
